import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654856a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current-data-popup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "データ取得日時", -1))
const _hoisted_3 = { class: "panel-heading" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-heading-main flex flex-center" }, "降雨", -1))
const _hoisted_5 = { class: "panel-heading-sub flex flex-center" }
const _hoisted_6 = { class: "panel-body" }
const _hoisted_7 = { class: "panel panel-v flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-heading flex flex-center" }, [
  /*#__PURE__*/_createTextVNode("10分間移動"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("積算雨量")
], -1))
const _hoisted_9 = { class: "panel-body" }
const _hoisted_10 = { class: "main-value" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_13 = { class: "flex sub-values" }
const _hoisted_14 = { class: "sub-values-box max-value flex" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "日最大", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_18 = { class: "sub-values-box start-time flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "起時", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "panel panel-v flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-heading flex flex-center" }, [
  /*#__PURE__*/_createTextVNode("1時間移動"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("積算雨量")
], -1))
const _hoisted_23 = { class: "panel-body" }
const _hoisted_24 = { class: "main-value" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_27 = { class: "flex sub-values" }
const _hoisted_28 = { class: "sub-values-box max-value flex" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "日最大", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_32 = { class: "sub-values-box start-time flex" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "起時", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "panel panel-v panel-v-mini hide-pc flex" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-heading flex flex-center" }, [
  /*#__PURE__*/_createTextVNode("日積算"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("雨量")
], -1))
const _hoisted_37 = { class: "panel-body" }
const _hoisted_38 = { class: "main-value" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_41 = { class: "panel panel-v panel-v-mini flex hide-pc" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-heading flex flex-center" }, [
  /*#__PURE__*/_createTextVNode("累計"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("雨量")
], -1))
const _hoisted_43 = { class: "panel-body" }
const _hoisted_44 = { class: "main-value" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))

import { computed, ref } from 'vue'
import moment from 'moment'
import { formatStatusTime } from '@/lib/formatter'
import { usePresentStore } from '@/stores/presentStore'
import { useGlobalStore } from '@/stores/globalStore'
import { Present } from '@/models/Present'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const RAIN_FALL_LEVEL = {
  NOTHING: 'nothing',
  LOW: 'low',
  MIDDLE: 'middle',
  HIGH: 'high',
}

const RAIN_FALL_LEVEL_TEXTS = {
  [RAIN_FALL_LEVEL.NOTHING]: '無',
  [RAIN_FALL_LEVEL.LOW]: '弱',
  [RAIN_FALL_LEVEL.MIDDLE]: '中',
  [RAIN_FALL_LEVEL.HIGH]: '強',
}

const showPopup = ref<boolean>(false)
const globalStore = useGlobalStore()
const presentStore = usePresentStore()
const currentData = computed(() => {
  if (!globalStore.currentStation) {
    return {} as Present
  }

  return presentStore.findByStationId(globalStore.currentStation.stationId) || ({} as Present)
})

const rainfallLevel = computed(() => {
  const value = currentData.value
  const alerts = value?.alertLevel

  if (!value || !value.moveRainMin10 === undefined || !value.moveRainMin60 === undefined || !alerts) {
    return RAIN_FALL_LEVEL.NOTHING
  }

  if (alerts.moveRainMin10 === 'warn2' || alerts.moveRainMin60 === 'warn2') {
    return RAIN_FALL_LEVEL.HIGH
  }

  if (alerts.moveRainMin10 === 'warn1' || alerts.moveRainMin60 === 'warn1') {
    return RAIN_FALL_LEVEL.MIDDLE
  }

  if (value.moveRainMin10 > 0.5 || value.moveRainMin60 > 0.5) {
    return RAIN_FALL_LEVEL.LOW
  }

  return RAIN_FALL_LEVEL.NOTHING
})

const rainfallLevelText = computed(() => {
  return RAIN_FALL_LEVEL_TEXTS[rainfallLevel.value]
})

const rainfallLevelValue = computed(() => {
  if (!currentData.value || !currentData.value.moveRainMin10) {
    return 0
  }

  return Object.values(RAIN_FALL_LEVEL).indexOf(rainfallLevel.value)
})

const fetchTime = computed(() => {
  return moment(currentData.value.time).format('YYYY年MM月DD日 HH:mm')
})

const formatTime = (time: string, value: number) => {
  if (!time) {
    return '--:--'
  }

  if (value !== undefined && value === 0) {
    return '--:--'
  }

  return formatStatusTime(time, 'hour')
}

const maxMoveRainMin10OfDayTime = computed(() => {
  return formatTime(currentData.value.maxMoveRainMin10OfDayTime, currentData.value.maxMoveRainMin10OfDay)
})

const maxMoveRainMin60OfDayTime = computed(() => {
  return formatTime(currentData.value.maxMoveRainMin60OfDayTime, currentData.value.maxMoveRainMin60OfDay)
})

const renderValue = (value?: number) => {
  if (value === undefined || value === null) {
    return '-'
  }

  return value.toFixed(1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(rainfallLevel), "current-data"])
  }, [
    _createElementVNode("div", {
      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showPopup.value = false)),
      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (showPopup.value = true)),
      class: "panel panel-v flex"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_unref(fetchTime)), 1)
      ], 512), [
        [_vShow, showPopup.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(rainfallLevelText)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["circles", `circles-${_unref(rainfallLevelValue)}`])
        }, null, 2)
      ])
    ], 32),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(renderValue(_unref(currentData).moveRainMin10)), 1),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(renderValue(_unref(currentData).maxMoveRainMin10OfDay)), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(maxMoveRainMin10OfDayTime)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(renderValue(_unref(currentData).moveRainMin60)), 1),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(renderValue(_unref(currentData).maxMoveRainMin60OfDay)), 1),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(maxMoveRainMin60OfDayTime)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, _toDisplayString(renderValue(_unref(currentData).rainDay)), 1),
          _hoisted_40
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, _toDisplayString(renderValue(_unref(currentData).rainRui)), 1),
          _hoisted_46
        ])
      ])
    ])
  ], 2))
}
}

})